import { Pipe, PipeTransform, NgModule } from '@angular/core';
//https://www.c-sharpcorner.com/article/creating-custom-pipe-using-safehtml-in-angular-5/
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'customCssDevID'
})

export class MapsPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: string): SafeHtml {

    //let devIDValue = '<span style="font-style:italic;">All Devices</span>';
    let devIDValue = 'All Devices';

    if (value == undefined || value == null || value == '') {
      //return this._sanitizer.bypassSecurityTrustHtml(devIDValue);
      return devIDValue;
    }
    else {
      //return this._sanitizer.bypassSecurityTrustHtml(value);
      return value;
    }
  }
}  


@NgModule({
  declarations: [MapsPipe],
  exports: [MapsPipe],
})
export class MapsPipeModule {}
